const mediaQuery = {
    query: null,
    watchIfDesktop: (mediaChange) => {
        mediaQuery.query =  window.matchMedia("(min-width: 960px)");
        mediaQuery.query.onchange = mediaChange;
        return mediaQuery.query.matches;
    },
    unsubscribe: () => {
        mediaQuery.query.onchange = null
    }
};

export default mediaQuery;
